// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__OE+r9","SearchBar--holdsValue":"SearchBar_SearchBar--holdsValue__tK2RB"};